//URL parameter helper function
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

function compatibilityClearContainer(callback) {
    compatibilityContainer.fadeOut(200, function () {
        compatibilityContainer.empty();
        $("#compatibilityChartLoading").css("display","block");
        callback();
    });
}

function compatibilityShowContainer() {
    compatibilityContainer.fadeIn(200);
    compatibilityHeader.fadeIn();
}


function compatibilityAddSearchBox() {
    compatibilityHeader.append($("#compatibilitySearchBoxTemplate").html());
    $("#compatibility_search_form").submit(function (e) {
        e.preventDefault();
        var query = $("#compatibility_search_field").val();
        if (query.length > 0)
            compatibilityLoadData(compatibilityEndpoint + '/series/search/' + query);
        else {

        }
    });
}

function compatibilityAddBackButton(breadcrumbs) {
    if (typeof(breadcrumbs) != "undefined") {
        if (breadcrumbs.length > 0) {
            var breadcrumb_html = '<div class="col-xs-12"><ol class="breadcrumb">';
            var breadcrumb_link = '';
            for (var f = 0; f < breadcrumbs.length; f++) {
                if (breadcrumbs[f].is_active != true) {
                    breadcrumb_link = '<li><a data-src="' + breadcrumbs[f].url + '" class="breadcrumbButton" data-href="' + breadcrumbs[f].loc + '" href="' + breadcrumbs[f].loc + '">' + breadcrumbs[f].name + '</a></li>';
                }
                else {
                    breadcrumb_link = '<li class="active">' + breadcrumbs[f].name + '</li>';
                }
                breadcrumb_html += breadcrumb_link
            }
            compatibilityHeader.append(breadcrumb_html);
            $(".breadcrumbButton").click(function (e) {
                e.preventDefault();
                if ($(this).attr('data-src') != 'undefined') {
                    history.pushState({url: '?dt=' + $(this).attr('data-href')}, "", $(this).attr('data-href'));
                    compatibilityLoadData($(this).attr('data-src'));
                }
            });
        }
    }
}

function compatibilityLoadData(xhref) {
    if (is_loading == false) {
        is_loading = true;
            $.getJSON(xhref, function (data) {
                if (data.result == true) {
                    $("#compatibilityChartLoading").css("display","none");
                    // Defining templates
                    switch (data.template) {
                        case "LoadDetails":
                            // TODO: FIX THE SWITCHER
                            compatibilityContainer.append(compatibilityParseDetails(data));
                            $(".compatible-details-products-btn").click(function (e) {
                                e.preventDefault();
                                $("#compatible-details-switch li").removeClass("active");

                                $("#compatible_series").fadeToggle(
                                    function () {
                                        $("#compatible_apps").fadeToggle();
                                    }
                                );
                            });

                    compatibilityShowContainer();
                }
            }
          });
            is_loading = false;
    }
}

function compatibilityParseDetails(data) {
    var template = $("#alia1").html();
    //Basics
    template = template.replace('[NAME]', data.name)
        .replace(/\[ALT_NAME]/g, data.name)
        .replace('[DATA_NAME]', data.image_url)
        .replace('[IMAGE_URL]', data.image_url)
        .replace(/\[PAGE_URL]/g, data.pdp_url)
        .replace('[KEYWORDS]', 'Models: ' + data.keywords);
    // Apps
    var a = 0, b = 0;

    // Series
    if (data.series.length > 0) {
        var series_template = $("#alia2").html();
        var series_list = "";
        for (b = 0; b < data.series.length; b++) {
            series_list += series_template.replace('[NAME]', data.series[b].name)
                .replace('[IMAGE_URL]', data.series[b].image_url)
                .replace('[TYPE]', data.series[b].type)
                .replace(/\[PDP_URL]/g, data.series[b].pdp_url)
                .replace(/\[DATA_ID]/g, data.series[b].id)
                .replace(/\[CTA]/g, data.series[b].pivot.custom_is_compatible_text)
                .replace(/\[custom_cta_url]/g, data.series[b].pivot.custom_cta_url)
                .replace(/\[custom_cta]/g, data.series[b].pivot.custom_cta)
                .replace(/\[custom_disclaimer]/g, data.series[b].pivot.custom_disclaimer);

            if (b % 4 == 3 && b > 0) {
                series_list += '<div class="clearfix"></div>';
            }
        }

        template = template.replace('[SERIES]', series_list);
    }
    else {
        template = template.replace('[SERIES]', "<div class='col-xs-12'><div class='alert alert-danger'>No supported products</div></div>");
    }
    return template;
}

function compatibilityParseSeries(data) {

    var template_html = '';
    if (data.total > 0) {
        for (var i = 0; i < data.total; i++) {

            var template = $("#compatibilityProductSeriesTemplate").html();
            template = template.replace('[NAME]', data.series[i].name)
                .replace('[TOTAL]', data.series[i].total)
                .replace('[IMAGE_URL]', data.series[i].image_url)
                .replace(/\[PAGE_URL]/g, data.series[i].pdp_url)
                .replace(/\[COMPATIBILITY_URL]/g, data.series[i].compatibility_url)
                .replace(/\[DATA_NAME]/g, data.series[i].type + '&dp=' + data.series[i].id);
            if (i % 2 == 0 && i > 0) {
                template_html += '<div class="w-100"></div>';
            }
            template_html += template;

        }
    }
    else {
        template_html = '<div class="col-xs-3 center"><div class="alert alert-info" role="alert"><strong>No results<strong></div></div>';
    }
    return template_html;
}

function compatibilityParseTypes(data) {
    var template_html = '';

    for (var i = 0; i < data.groups.length; i++) {
        template_html += '<div class="col-xs-12"><h3>' + data.groups[i].title + '</h3></div>';
        for (var k = 0; k < data.groups[i].categories.length; k++) {

            var template = $("#compatibilityProductTypesTemplate").html();
            template = template
                .replace(/\[ALT_NAME]/g, data.groups[i].categories[k].name)
                .replace('[NAME]', data.groups[i].categories[k].name)
                .replace('[CLASS_NAME]', data.groups[i].categories[k].name.replace(" ", "_"))
                .replace('[TOTAL]', data.groups[i].categories[k].total)
                .replace('[IMAGE_URL]', data.groups[i].categories[k].image)
                .replace(/\[PAGE_URL]/g, data.groups[i].categories[k].url)
                .replace(/\[DATA_NAME]/g, data.groups[i].categories[k].name);
            if (k % 4 == 3 && k > 0) {
                compatibilityContainer.append('<div class="clearfix"></div>');
            }
            template_html += template;
        }
    }
    return template_html

}

var compatibilityContainer = $("#compatibilityChartContainer");
var compatibilityHeader = $("#compatibilityChartHeader");
var compatibilityEndpoint = 'https://lorexreviews.com/api/v2/product';
var is_loading = false;
var dp = getUrlParameter('dp');
var dt = getUrlParameter('dt');

$("document").ready(function () {
    if (typeof(dp) != 'undefined') {
        //data point url present
        compatibilityLoadData(compatibilityEndpoint + '/compatibility/' + dp);
    }
    else {
        if (typeof(dt) != 'undefined') {
            compatibilityLoadData(compatibilityEndpoint + '/series/type/' + dt);
        }
        else {
            compatibilityLoadData(compatibilityEndpoint + '/series/types');
        }
    }
});